import React from 'react';
import PropTypes from 'prop-types';
import {
  FDStack, FDLozenge,
} from '@facet-wealth/design';
import { useDataAttrs } from 'Helpers/Testing';

export const LozengeMultiPicklist = ({
  label,
  value,
  options,
  direction,
  ...rest
}) => {
  const checked = new Set(!value ? [] : value);
  return (
    <FDStack {...useDataAttrs(rest)} direction={direction} spacing={direction === 'horizontal' ? 3 : 1} alignItems="center">
      {options
        .filter(option => checked.has(option.id))
        .map(option => (
          <FDLozenge
            key={option.id}
            label={option.prompt}
            color="warning"
          />
        ))}
    </FDStack>
  );
};

LozengeMultiPicklist.defaultProps = {
  value: [],
  direction: 'row',
};

LozengeMultiPicklist.propTypes = {
  value: PropTypes.array,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  direction: PropTypes.oneOf(['column', 'row']),
};
